function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { loadState } from "../../store/Utilities/State";
import { getHasAnsweredAllQuestions } from "../../store/Selectors";
import { DiscreteSchemeGrade, DuolingoScore, GmatScore, GreScore, HighestEducation, IeltsScore, Nationality, NumericSchemeGrade, PteScore, Residency, SchemelessGrade, StudyPermits, ToeflScore } from "./";
import { NoEnglishScore } from "./NoEnglishScore";
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}
export var EligibilityAnswers = /*#__PURE__*/function () {
  function EligibilityAnswers(complete, discreteSchemeGrade, duolingoScore, gmatScore, greScore, highestEducation, ieltsScore, nationality, numericSchemeGrade, pteScore, residency, schemelessGrade, studyPermits, toeflScore, noEnglishScore) {
    _classCallCheck(this, EligibilityAnswers);
    this.complete = complete;
    this.discreteSchemeGrade = discreteSchemeGrade;
    this.duolingoScore = duolingoScore;
    this.gmatScore = gmatScore;
    this.greScore = greScore;
    this.highestEducation = highestEducation;
    this.ieltsScore = ieltsScore;
    this.nationality = nationality;
    this.numericSchemeGrade = numericSchemeGrade;
    this.pteScore = pteScore;
    this.residency = residency;
    this.schemelessGrade = schemelessGrade;
    this.studyPermits = studyPermits;
    this.toeflScore = toeflScore;
    this.noEnglishScore = noEnglishScore;
  }
  _createClass(EligibilityAnswers, null, [{
    key: "emptyAnswers",
    value: function emptyAnswers() {
      return new EligibilityAnswers(false, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    }
  }, {
    key: "fromStorage",
    value: function fromStorage() {
      var state = loadState();
      if (isEmptyObject(state)) {
        return EligibilityAnswers.emptyAnswers();
      }
      return EligibilityAnswers.fromDsjState(state);
    }
  }, {
    key: "fromDsjState",
    value: function fromDsjState(state) {
      if (!state) {
        return EligibilityAnswers.emptyAnswers();
      }
      var complete = getHasAnsweredAllQuestions(state);
      return new EligibilityAnswers(complete, DiscreteSchemeGrade.fromDsjState(state), DuolingoScore.fromDsjState(state), GmatScore.fromDsjState(state), GreScore.fromDsjState(state), HighestEducation.fromDsjState(state), IeltsScore.fromDsjState(state), Nationality.fromDsjState(state), NumericSchemeGrade.fromDsjState(state), PteScore.fromDsjState(state), Residency.fromDsjState(state), SchemelessGrade.fromDsjState(state), StudyPermits.fromDsjState(state), ToeflScore.fromDsjState(state), NoEnglishScore.fromDsjState(state));
    }
  }]);
  return EligibilityAnswers;
}();